import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { AccesibilityComponent } from './components/accesibility/accesibility.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { RouterModule } from "@angular/router";
import { SigninComponent } from './components/signin/signin.component';
import { ReactiveFormsModule } from "@angular/forms";
import { LoaderComponent } from './components/loader/loader.component';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  declarations: [
    FooterComponent,
    HeaderComponent,
    AccesibilityComponent,
    BreadcrumbComponent,
    SigninComponent
  ],
  exports: [
    FooterComponent,
    HeaderComponent,
    AccesibilityComponent,
    BreadcrumbComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    HttpClientModule
  ]
})
export class CoreModule { }

export class AppModule {}
